// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"118":"54a54b5b","1613":"16a2bdff","6658":"16a2bdff"}[chunkId] + ".chunk.css";
};